<template>
    <v-container fill-height fluid grid-list-xl class="pt-0">
        <v-layout wrap>
            <v-flex xs12 class="pt-0">
                <material-card color="green">
                    <v-flex slot="header">
                        <v-layout row>
                            <span
                                class="subheading font-weight-light mr-3"
                                style="align-self: center"
                                >Audio:</span
                            >
                            <v-spacer></v-spacer
                            ><v-btn
                                small
                                class="mr-2 my-0"
                                style="background-color: #fff; color: #4caf50 !important"
                                @click="openUploadAudio()"
                            >
                                Upload Audio
                            </v-btn>
                        </v-layout>
                    </v-flex>
                    <v-data-table
                        :headers="headers"
                        :items="audioList"
                        v-bind:pagination.sync="pagination"
                        hide-actions
                        disable-initial-sort
                    >
                        <template slot="headerCell" slot-scope="{ header }">
                            <span
                                class="font-weight-light text-success text--darken-3"
                                v-text="header.text"
                            />
                        </template>
                        <template slot="items" slot-scope="{ index, item }">
                            <tr
                                @click="viewAudio(item)"
                                style="cursor: pointer;"
                            >
                                <td>
                                    <v-tooltip top dark>
                                        <template #activator="{ on }" dark>
                                            <v-icon
                                                v-on="on"
                                                dark
                                                :color="
                                                    getStatusIconColor(
                                                        item.status,
                                                    )
                                                "
                                                >{{
                                                    getStatusIcon(item.status)
                                                }}</v-icon
                                            >
                                        </template>
                                        <span dark>{{ item.Status }}</span>
                                    </v-tooltip>
                                </td>
                                <td class="font-weight-regular">
                                    {{ item.user }}
                                </td>
                                <td class="text-xs-left font-weight-regular">
                                    {{ item.optionNumber }}
                                </td>

                                <td class="text-xs-left font-weight-regular">
                                    {{ item.date }}
                                </td>
                                <td>
                                    <audio
                                        controls
                                        :src="item.recordingUrl"
                                    ></audio>
                                </td>
                                <td class="text-xs-left font-weight-regular">
                                    {{ item.uploadedOn }}
                                </td>
                                <td class="text-xs-left font-weight-regular">
                                    <v-btn
                                        @click.stop="openDeleteAudio(item)"
                                        color="success"
                                        flat
                                        icon
                                        ><v-icon
                                            >mdi-close-circle</v-icon
                                        ></v-btn
                                    >
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                    <div class="text-xs-center mt-2">
                        <v-pagination
                            v-model="pagination.page"
                            :length="pages"
                            :total-visible="5"
                        ></v-pagination>
                    </div>
                </material-card>
            </v-flex>
        </v-layout>
        <v-dialog v-model="deleteDialog" max-width="400px">
            <v-card class="pa-3">
                <div class="headline mb-3">Delete Audio File</div>

                <audio controls :src="audioToDelete.recordingUrl"></audio>

                <v-card-actions class="mt-2 mr-0 pb-0">
                    <v-spacer></v-spacer>
                    <v-btn color="default" dark @click="deleteDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="deleteAudio()"
                    >
                        Delete
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="viewAudioDialog" max-width="500">
            <v-card class="pa-4">
                <div class="title px-0 pb-0">Listeners</div>

                <v-progress-linear
                    v-if="loading"
                    :indeterminate="true"
                    color="success"
                ></v-progress-linear>
                <div
                    class="mb-3 mt-2 pa-2"
                    style="border: 2px solid #43a047;"
                    v-if="!loading"
                >
                    <div v-for="(info, index) in clickedAudio.listeners">
                        <v-layout row>
                            <div
                                style="width: 130px"
                                class="font-weight-medium"
                            >
                                {{ info.name }}
                            </div>
                            <div style="width: 100px">{{ info.time }}</div>
                            <div>{{ info.lastTime }}</div> </v-layout
                        ><v-divider
                            class="mb-2 mt-1"
                            v-if="index + 1 < clickedAudio.listeners.length"
                        ></v-divider>
                    </div>
                    <v-divider class="mt-2"></v-divider>
                </div>
                <v-card-actions class="mx-0">
                    <v-spacer></v-spacer>
                    <v-btn @click="viewAudioDialog = false" color="#999" dark
                        >Close</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="uploadAudioDialog" max-width="400px">
            <v-card class="pa-3">
                <div class="headline mb-2">Upload Audio</div>

                <v-btn
                    small
                    class="mr-2 mt-3"
                    color="success"
                    :loading="uploading"
                    @click="pickAudioFile()"
                >
                    Upload
                    <v-icon right dark>mdi-cloud-upload</v-icon>
                </v-btn>
                <v-text-field
                    v-model="audio.optionNumber"
                    label="Option Number"
                    class="mx-2 mt-3"
                    style="max-width: 290px;"
                ></v-text-field>
                <input
                    type="file"
                    style="display: none"
                    ref="audioFiles"
                    accept=".mp3"
                    @change="onAudioFilePicked($event)"
                />
                <div
                    v-if="audio.files && audio.files.length"
                    class="pt-2 mb-3 ml-2"
                >
                    {{ audio.files[0].name }}
                </div>
                <template>
                    <v-menu
                        v-model="datePickerMenu"
                        :close-on-content-click="true"
                        :nudge-right="40"
                        lazy
                        transition="scale-transition"
                        offset-y
                        class="date-picker-menu"
                        max-width="290px"
                    >
                        <template v-slot:activator="{ on }">
                            <v-text-field
                                v-model="audio.date"
                                label="Date"
                                class="mx-2 text-black"
                                readonly
                                color="green"
                                style="max-width: 200px; background-color: #fff;"
                                v-on="on"
                                hide-details
                            ></v-text-field>
                        </template>
                        <v-date-picker
                            style="color: black !important;"
                            v-model="audio.date"
                        ></v-date-picker>
                    </v-menu>
                    <v-layout row wrap class="my-3">
                        <v-flex md12 lg6>
                            <v-time-picker
                                v-model="audio.time"
                                color="green lighten-1"
                            ></v-time-picker>
                        </v-flex>
                    </v-layout>
                </template>
                <div class="my-3 text-danger" v-if="audio.error">
                    {{ audio.error }}
                </div>
                <v-card-actions class="mt-2 mr-0 pb-0">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="uploadAudioDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="save()"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import ky from "ky";
import moment from "moment";
import * as firebase from "firebase/app";
import "firebase/database";
import { toISOLocal } from "../utils/helpers.js";

export default {
    data() {
        return {
            rowsPerPageItems: [10, 20],
            pagination: {
                totalItems: 0,
                rowsPerPage: 10,
                page: 1,
            },

            uploadAudioDialog: false,
            processing: false,
            datePickerMenu: false,
            audio: {
                files: [],
                date: toISOLocal(new Date(moment())).substr(0, 10),
                optionNumber: "2",
                time: null,
                error: "",
            },

            headers: [
                { value: "Status", text: "Status" },
                { value: "user", text: "User" },
                { value: "optionNumber", text: "Option Number" },
                { value: "date", text: "Time" },
                { value: "recordingUrl", text: "Recording" },
                { value: "uploadedOn", text: "Uploaded On" },
            ],

            audioList: [],
            uploading: false,
            uploadingGreeting: false,
            viewAudioDialog: false,
            clickedAudio: {},
            loading: false,

            deleteDialog: false,
            audioToDelete: {},
        };
    },
    computed: {
        pages() {
            return this.pagination.rowsPerPage
                ? Math.ceil(
                      this.pagination.totalItems / this.pagination.rowsPerPage,
                  )
                : 0;
        },
    },
    created() {
        //this.firebaseSetup();
        this.audio.time = this.getCurrentTime();

        this.loadData();
    },
    methods: {
        getDomain() {
            return window.location.host.includes("localhost")
                ? "https://localhost:44337"
                : "https://broadcastmessageswercber.azurewebsites.net";
        },
        getStatusIcon(status) {
            switch (status) {
                case "Completed":
                    return "mdi-check-circle";
                case "Pending":
                    return "mdi-clock";
            }
        },
        getStatusIconColor(status) {
            switch (status) {
                case "Completed":
                    return "success";
                case "Pending":
                    return "#fdb400";
            }
        },
        getCurrentTime() {
            var now = new Date(); // get current date
            var hours = now.getHours(); // get hours from date
            var minutes = now.getMinutes(); // get minutes from date
            var seconds = now.getSeconds(); // get seconds from date

            // format hours to have 2 digits
            hours = ("0" + hours).slice(-2);
            // format minutes to have 2 digits
            minutes = ("0" + minutes).slice(-2);
            // format seconds to have 2 digits
            seconds = ("0" + seconds).slice(-2);

            var time = hours + ":" + minutes; // combine hours, minutes, and seconds with ":" in between
            return time; // output: 13:25:45
        },
        async viewAudio(audio) {
            this.clickedAudio = {};
            this.viewAudioDialog = true;

            try {
                this.loading = true;

                const url =
                    this.getDomain() +
                    "/api/broadcast/GetListenersSql?recordingURL=" +
                    audio.id +
                    "&type=audio";

                const response = await this.$http.get(url);
                audio.listeners = response.data.listeners.map((listener) => {
                    listener.lastTime = moment(listener.lastTime).format(
                        "MM/DD/YYYY h:mm:ss A",
                    );

                    return listener;
                });

                this.clickedAudio = audio;

                this.loading = false;
            } catch (e) {
                this.loading = false;
            }
        },
        // firebaseSetup() {
        //     const firebaseConfig = {
        //         apiKey: "Xs6kU5UjjL8n5LdLQJMGnWcaEietBLrj5U9FnpIb",
        //         authDomain: "broadcast-b7a56.firebaseapp.com",
        //         databaseURL: "https://broadcast-b7a56.firebaseio.com",
        //         projectId: "broadcast-b7a56",
        //     };

        //     // Initialize Firebase
        //     if (!firebase.apps.length) {
        //         firebase.initializeApp(firebaseConfig);
        //     }

        //     var database = firebase.database();
        //     var ref = firebase.database().ref("greetings");

        //     const greetingsRef = ref.orderByKey().limitToLast(100);

        //     greetingsRef.on(
        //         "value",
        //         (snapshot) => {
        //             const greetings = Object.values(snapshot.val()).map(
        //                 (message) => {
        //                     message.FromPhone = this.formatPhoneNumber(
        //                         message.FromPhone
        //                     );

        //                     message.Date = moment(message.Timestamp).format(
        //                         "LLL"
        //                     );

        //                     return message;
        //                 }
        //             );
        //             this.greetings = greetings.sort((a, b) => {
        //                 if (Date.parse(a.Timestamp) > Date.parse(b.Timestamp))
        //                     return -1;
        //                 if (Date.parse(a.Timestamp) < Date.parse(b.Timestamp))
        //                     return 1;
        //                 return 0;
        //             });

        //             this.pagination.totalItems = this.greetings.length;
        //         },
        //         function(error) {
        //             console.log("Error: " + error.code);
        //         }
        //     );

        //     ref.on("child_added", (data, prevChildKey) => {});
        // },
        formatPhoneNumber(phoneNumberString) {
            var cleaned = ("" + phoneNumberString).replace(/\D/g, "");
            var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
            if (match) {
                return "(" + match[1] + ") " + match[2] + "-" + match[3];
            }
            return null;
        },
        async loadData() {
            const response = await this.$http.get(
                this.getDomain() + "/api/home/getAudio",
            );

            this.pagination.totalItems = response.data.length;

            const now = new Date();

            this.audioList = response.data.map((a) => {
                a.date = moment(a.date).format("LLL");
                a.uploadedOn = a.uploadedOn
                    ? moment(a.uploadedOn).format("LLL")
                    : "";
                a.status = new Date(a.date) > now ? "Pending" : "Completed";

                return a;
            });
        },
        getDomain() {
            return window.location.origin.startsWith("http://localhost")
                ? "https://localhost:44337"
                : "https://broadcastmessageswercber.azurewebsites.net";
        },
        openUploadAudio() {
            this.audio.files = [];
            this.uploadAudioDialog = true;
        },
        pickAudioFile() {
            this.$refs.audioFiles.click();
        },
        async onAudioFilePicked(e) {
            this.uploading = true;

            const files = e.target.files;

            if (!files) return;

            this.audio.files = files;

            this.uploading = false;
        },
        async save() {
            if (!this.audio.time) {
                this.audio.error = "Missing Time";
                return;
            }

            if (!this.audio.date) {
                this.audio.error = "Missing Date";
            }

            if (!this.audio.files.length) {
                this.audio.error = "Please Upload File";

                return;
            }

            this.audio.error = "";

            var formData = new FormData();

            formData.append("file", this.audio.files[0]);

            try {
                this.processing = true;

                const date = this.audio.date + " " + this.audio.time;

                await this.$http.post(
                    this.getDomain() +
                        "/api/home/UploadFile?type=audio&user=" +
                        this.$store.state.user +
                        "&date=" +
                        date +
                        "&group=" +
                        this.audio.optionNumber,
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    },
                );

                this.processing = false;
                this.uploadAudioDialog = false;
                this.loadData();
            } catch (e) {
                this.processing = false;
            }
        },
        openDeleteAudio(item) {
            this.audioToDelete = item;
            this.deleteDialog = true;
        },
        async deleteAudio() {
            try {
                this.processing = true;

                await this.$http.post(
                    this.getDomain() +
                        "/api/home/deleteAudio?id=" +
                        this.audioToDelete.id,
                );

                this.processing = false;
                this.deleteDialog = false;
                this.loadData();
            } catch (e) {
                this.processing = false;
            }
        },
    },
};
</script>
<style>
tbody tr:nth-child(even) {
    background-color: #eee;
}
.v-date-picker-table .v-btn {
    color: rgba(0, 0, 0, 0.87) !important;
}
</style>
